// All environment-specific values (URLs, keys, project IDs) come from
// each app's own env vars. This file is reserved for truly static,
// environment-independent constants shared across apps.

export const APP_NAME = "PROduce";
export const CACHE_EXPIRY_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
export const MAX_OFFLINE_GPS_QUEUE = 500;

// PRO plan: published productions per calendar year. Enforced in the database
// by enforce_production_limit (keep the two in step).
export const PRO_PRODUCTIONS_PER_YEAR = 10;

// Where crew and producers reach a person. Shown as text in the apps.
export const SUPPORT_EMAIL = "support@produce-app.com";
